import {CoreDI} from '@gongxigames/framework/core/configs/CoreDI';
import {IEventManagerWithAsync} from '@gongxigames/framework/core/types/IEventManager';
import {inversifyContainer} from '@gongxigames/framework/core/installer/inversify.config';
import {DI} from '@gongxigames/framework/slot/configs/DI';
import {UpdateManager} from '@gongxigames/framework/core/services/UpdateManager';
import {GameConfig} from '@gongxigames/framework/slot/types/GameConfig';
import {CurrencyFormatter, Device, Installer, ISettings, ISoundPlayer, LanguageService} from '@gongxigames/framework/core';
import {EnvironmentProperty, ResourceManager} from '@gongxigames/framework/slot';

export class ActDecorator {
    private _eventManager!: IEventManagerWithAsync;
    private _updateManager!: UpdateManager;
    private _gameConfig!: GameConfig;
    private _settings!: ISettings;
    private _resourceManager!: ResourceManager;
    private _languageService!: LanguageService;
    private _soundPlayer!: ISoundPlayer;
    private _currencyFormatter!: CurrencyFormatter;
    private _installer!: Installer;
    private _environmentProperty!: EnvironmentProperty;
    private _device!: Device;

    protected abortController = new AbortController();
    protected abortSignal = this.abortController.signal;

    protected get eventManager(): IEventManagerWithAsync {
        this._eventManager ??= inversifyContainer.get<IEventManagerWithAsync>(CoreDI.IEventManagerWithAsync);

        return this._eventManager;
    }

    public get updateManager(): UpdateManager {
        this._updateManager ??= inversifyContainer.get<UpdateManager>(CoreDI.UpdateManager);

        return this._updateManager;
    }

    protected get gameConfig(): GameConfig {
        this._gameConfig ??= inversifyContainer.get<GameConfig>(CoreDI.GameConfig);

        return this._gameConfig;
    };

    protected get settings(): ISettings {
        this._settings ??= inversifyContainer.get<ISettings>(CoreDI.Settings);

        return this._settings;
    }

    public get resourceManager(): ResourceManager {
        this._resourceManager ??= inversifyContainer.get<ResourceManager>(DI.ResourceManager);

        return this._resourceManager;
    }

    public get languageService(): LanguageService {
        this._languageService ??= inversifyContainer.get<LanguageService>(CoreDI.LanguageService);

        return this._languageService;
    }

    public get soundPlayer(): ISoundPlayer {
        this._soundPlayer ??= inversifyContainer.get<ISoundPlayer>(DI.SoundPlayer);

        return this._soundPlayer;
    }

    public get currencyFormatter(): CurrencyFormatter {
        this._currencyFormatter ??= inversifyContainer.get<CurrencyFormatter>(CoreDI.CurrencyFormatter);

        return this._currencyFormatter;
    }

    public get installer(): Installer {
        this._installer ??= inversifyContainer.get<Installer>(CoreDI.Installer);

        return this._installer;
    }

    public get environmentProperty(): EnvironmentProperty {
        this._environmentProperty ??= inversifyContainer.get<EnvironmentProperty>(CoreDI.EnvironmentProperty);

        return this._environmentProperty;
    }

    public get device(): Device {
        this._device ??= inversifyContainer.get<Device>(CoreDI.Device);

        return this._device;
    }

    public removeAllListeners(): void {
        this.eventManager.offAllFromOwner(this);
        this.abortController.abort();
    }
}